import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import FormulaSection from './components/FormulaSection';

export default function ServicePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Ensure the page starts at the top when the component mounts
    window.scrollTo(0, 0);

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    // Clean‑up to avoid memory leaks
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      titleEn: 'Experience Design',
      titleJa: '体験設計・顧客体験の設計と改善',
      description:
        '顧客体験の設計から改善まで。購買ではなく"発見"、取引ではなく"愛着"を生む体験をデザインします。EC、キャンペーン、サービス設計など、あらゆる接点を「また触れたくなる」体験に変えていきます。',
    },
    {
      titleEn: 'Brand & Communication Design',
      titleJa: 'ブランド戦略・コミュニケーション設計',
      description:
        '企業やサービスの価値を言語化し、共感を生むブランドの姿を設計。ブランド戦略からメッセージング、ビジュアルアイデンティティまで一貫して構築します。',
    },
    {
      titleEn: 'Creative Development',
      titleJa: '顧客体験を軸にした各種クリエイティブ制作',
      description:
        '体験を形にするクリエイティブを開発。Webサイト、アプリ、キャンペーンサイト、SNS運用まで、デザインから実装までワンストップで対応します。',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header scrolled={scrolled} />

      <main className="flex-1 pt-20">
        {/* Hero Section */}
        <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-[1400px] mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
              HOW WE CRAFT
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              目指すのは、あらゆる接点を<br />
              &quot;また触れたくなる体験&quot;に変えること。<br />
              &nbsp;私たちはこれを<br />
              エンターテイメントデザイン<br />
              と呼んでいます。<br />
              ブランド体験の設計から<br />
              デジタルプロダクトの開発まで、<br />
              ビジネスの成長を一貫して支援します。 <br />
              クライアントと受注側<br />
              という関係ではなく、<br />
              同じゴールを見据えるパートナー<br />
              として、戦略から実装までを<br />
              プロデュースします。
            </p>
          </div>
        </section>

        {/* Formula Section */}
        <FormulaSection />

        {/* Services List Section */}
        <section className="bg-white py-20 px-6 lg:px-12">
          <div className="max-w-[1400px] mx-auto">
            <div className="border-t border-gray-200">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="group border-b border-gray-200 py-10 lg:py-14 flex flex-col lg:flex-row lg:items-start gap-6 lg:gap-16 cursor-pointer hover:bg-gray-50 transition-colors duration-300 px-2 lg:px-4"
                >
                  {/* Left: Title */}
                  <div className="lg:w-[420px] flex-shrink-0">
                    <div className="mb-2">
                      <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 tracking-wide leading-tight">
                        {service.titleEn}
                      </h3>
                    </div>
                    <p className="text-sm text-gray-400 tracking-wider">
                      {service.titleJa}
                    </p>
                  </div>

                  {/* Right: Description */}
                  <div className="flex-1 lg:pt-1">
                    <p className="text-base text-gray-700 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-gray-700 to-gray-800">
          <div className="max-w-[1400px] mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-white">
              お気軽にご相談ください
            </h2>
            <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto">
              貴社のビジネス課題について、まずはお話をお聞かせください
            </p>
            <a
              href="/contact"
              className="inline-block bg-white text-gray-800 px-10 py-4 rounded-full font-semibold text-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
